import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import Logo from "./assets/logo.jpg";
// import { logoWrapperStyles } from "./styles";

/**
 * Пропсы для компонента `HeaderLogotype`.
 */
interface HeaderLogotypeProps {
  /** Путь, на который будет вести логотип */
  to: string;
}

/**
 * Компонент логотипа в заголовке.
 *
 * Отображает логотип в виде ссылки, ведущей на указанный путь.
 *
 * @param {HeaderLogotypeProps} props Пропсы компонента
 * @returns React-компонент логотипа
 */
export const HeaderLogotype = ({ to }: HeaderLogotypeProps) => {
  return (
    <Typography
      variant="h6"
      noWrap
      sx={{ display: { xs: "none", md: "flex" } }}
      component={Link}
      to={to}
    >
      {/* todo: clean hotfix */}
      {/* <Box sx={logoWrapperStyles}> */}
      <Box component="img" src={Logo} borderRadius={1} />
      {/* <Logo /> */}
      {/* </Box> */}
    </Typography>
  );
};
